import * as ActionType from '../../constants/actionType';

const initialProps = {
  isRenamed: false,
  isSelected: false,
  originalName: '',
  thumbnail: undefined,
  wellDepth: undefined,
};

const initialState = {
  1: initialProps,
  2: initialProps,
  3: initialProps,
  4: initialProps,
  5: initialProps,
  6: initialProps,
};

export default function labwareStateReducer(state = initialState, action = '') {
  switch (action.type) {
    case ActionType.SET_LABWARE_STATE:
      return action.labwareState;
    case ActionType.SET_LABWARE:
      return {...state, [action.labwarePos]: action.labware};
    case ActionType.REMOVE_LABWARE:
      return {...state, [action.labwarePos]: {}};
    case ActionType.SWITCH_LABWARE: {
      const labware1 = state[action.labwarePos1];
      const labware2 = state[action.labwarePos2];
      return {...state, [action.labwarePos1]: labware2, [action.labwarePos2]: labware1};
    }
    case ActionType.RENAME_LABWARE: {
      const isRenamed = state[action.labwarePos]?.isRenamed
        ? state[action.labwarePos]?.isRenamed
        : state[action.labwarePos].name !== action.name;

      return {...state, [action.labwarePos]: {...state[action.labwarePos], name: action.name, isRenamed}};
    }
    case ActionType.SELECT_LABWARE: {
      const newState = {};
      const stateKeys = Object.keys(state);
      for (let index = 0; index < stateKeys.length; index += 1) {
        const key = stateKeys[index];
        // eslint-disable-next-line eqeqeq
        if (key == action.labwarePos) {
          newState[key] = {...state[key], isSelected: true};
        } else {
          newState[key] = {...state[key], isSelected: false};
        }
      }
      return newState;
    }
    case ActionType.UNSELECT_LABWARE:
      return {...state, [action.labwarePos]: {...state[action.labwarePos], isSelected: false}};
    case ActionType.UNSELECT_ALL_LABWARE: {
      const newState = {};
      const stateKeys = Object.keys(state);
      for (let index = 0; index < stateKeys.length; index += 1) {
        const key = stateKeys[index];
        newState[key] = {...state[key], isSelected: false};
      }
      return newState;
    }
    case ActionType.RESTORE_LABWARESTATE:
      return action.state;
    case ActionType.RESET_LABWARESTATE:
      return initialState;
    case ActionType.SET_LABWARE_BARCODE: {
      return {...state, [action.labwarePos]: {...state[action.labwarePos], barcode: action.barcode}};
    }
    default:
      return state;
  }
}
